<template>
	<div class="cart-wrapper">
		<slot />
	</div>
</template>

<script>
import { defineComponent } from "vue";
/**
 * Cart wrapper is used in widget creation slide out. It holds the content of leftmost column in time-series widget creation slide out. Cart is contains cloud sources, data sources and metrics that user has selected to visualise in time-series widget while creating the widget.
 */
export default defineComponent({
	name: "CartWrapper"
});
</script>

<style lang="scss">
$border-color: var(--slideout-border);

.cart-wrapper {
	height: 100%;
	overflow-y: auto;
	border-right: 1px solid $border-color;
	width: 400px;
}
</style>
